import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AddedToZoomPage } from './components/AddedToZoomPage';
import './index.css';

// /auth/callback is the Marketplace OAuth redirect URL: a plain browser lands
// here after "Add to Zoom" + Allow. Everything else is the in-meeting app.
const path = window.location.pathname.replace(/\/+$/, '');
const Root = path === '/auth/callback' ? AddedToZoomPage : App;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
);
